import React from "react";
import { Col, Container, InputGroup, Row } from "react-bootstrap";
import Form from 'react-bootstrap/Form';


const ContactUs = () => {
    document.body.scrollTop = 0
    return (
        <Container>
            <Row className="pt-5">
                <div className="whitetitle">
                    <h2>Contact Us</h2>
                </div>
                <Col lg={12} md={12} sm={12} xs={12} className='p-5'>
                    <div className="p-5" >
                        <Form.Group className="mb-3">
                            <Form.Label>Full Name</Form.Label>
                            <Form.Control type="text" placeholder="Full Name" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Email Id</Form.Label>
                            <Form.Control type="email" placeholder="Email Id" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Phone Number</Form.Label>
                            <Form.Control type="number" placeholder="Phone Number" />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Meassage</Form.Label>
                            <Form.Control as="textarea" placeholder="Message" rows={3} />
                        </Form.Group>
                    </div>
                </Col>

            </Row>
        </Container>
    )
}

export default ContactUs;